// Labels from docs/spec/modules/scheduling.md (help-center screenshots; items marked unverified there keep the spec's text).
export const s = {
  title: "Schedule",
  sidebar: "Schedule",
  sidebarAlt: "View Schedule",
  tabProjects: "Projects",
  tabTeam: "Team",
  assignmentsReport: "Assignments report",
  previous: "Previous period",
  next: "Next period",
  showAll: "Show all",
  published: "Published",
  unpublished: "Unpublished",
  searchProjects: "Search projects or clients",
  members: "Members",
  users: "Users",
  groups: "Groups",
  searchUsers: "Search users",
  capacity: "Capacity",
  daily: "Daily",
  weekly: "Weekly",
  publish: "Publish",
  publishedBtn: "Published",
  zoomOut: "Zoom out",
  zoomIn: "Zoom in",
  projectTask: "Project - Task",
  assigned: "Assigned",
  amountCost: "Amount / Cost",
  addProject: "Add project",
  addMember: "Add member",
  searchProjectsPicker: "Search projects",
  searchMembers: "Search members",
  noSchedule: "No schedule for this period",
  addProjectHint: "Add a project and create assignments.",
  addMemberHint: "Add a member and create assignments.",
  noPublished: "You have no published assignments for this period.",
  noProjectsMatch: "No projects match your search",
  memberLink: "Member",
  projectLink: "Project",
  expand: "Expand",
  collapse: "Collapse",
  moreActions: "More actions",
  addMilestone: "Add milestone",
  editMilestone: "Edit milestone",
  shiftTimeline: "Shift timeline",
  hide: "Hide",
  editCapacity: "Edit capacity",
  hideProject: "Hide project",
  hideProjectBody: "This project will be hidden from the schedule. Its assignments will not be deleted.",
  hideMember: "Hide member",
  hideMemberBody: "Hiding this member will remove them from the schedule view. Their assignments will not be deleted.",
  hideBtn: "Hide",
  full: "Full",
  over: (h: string) => `${h}h over`,
  open: (h: string) => `${h}h open`,
  inactive: "(inactive)",
  invited: "Invited",
  unpublishedTag: "Unpublished",
  billable: "Billable",
  nonBillable: "Non-billable",
  createAssignment: "Create assignment",
  editAssignment: "Edit assignment",
  create: "Create",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  task: "Task",
  noTask: "No task",
  selectTask: "Select task",
  project: "Project",
  selectProject: "Select project",
  member: "Member",
  selectMember: "Select member",
  period: "Period",
  periodTooltip:
    "Assignment hours are added only to the member's working days. Weekends, holidays and time off are excluded.",
  workingDays: (n: number) => (n === 1 ? "1 working day" : `${n} working days`),
  today: "Today",
  includeNonWorking: "Include non-working days",
  hoursPerDay: "Hours per day",
  ofCapacity: (h: string) => `of ${h}`,
  totalHours: "Total hours:",
  startTime: "Start time",
  noStartTime: "No start time",
  cost: "Cost:",
  amount: "Amount:",
  note: "Note",
  addNote: "Add a note",
  repeat: "Repeat",
  none: "None",
  weeklyOn: (d: string) => `Weekly on ${d}`,
  every2Weeks: (d: string) => `Every 2 weeks on ${d}`,
  monthlyOnThe: (pos: string, d: string) => `Monthly on the ${pos} ${d}`,
  monthlyOnDay: (n: number) => `Monthly on day ${n}`,
  positions: ["first", "second", "third", "fourth", "last"] as const,
  endRepeat: "End repeat",
  on: "On",
  after: "After",
  occurrences: "occurrences",
  untilTooltip: "Assignment will repeat until this date",
  afterTooltip: "Assignment will repeat this many times",
  copy: "Copy",
  copyTo: "Copy to",
  delete: "Delete",
  deleteAssignment: "Delete assignment",
  deleteAssignmentBody: "Are you sure you want to delete this assignment?",
  editRecurring: "Edit recurring assignment",
  deleteRecurring: "Delete recurring assignment",
  copyRecurring: "Copy recurring assignment",
  thisOne: "This assignment",
  thisAndFollowing: "This and following assignments",
  allAssignments: "All assignments",
  ok: "OK",
  publishTitle: "Publish assignments",
  publishBody: "Once published, users will see their assignments.",
  notifyUsers: "Notify users",
  milestoneName: "Name",
  date: "Date",
  shiftBody: "Choose the new start date of your assignments.",
  newStartDate: "New start date",
  shift: "Shift",
  dailyCapacity: "Daily work capacity",
  workingDaysLabel: "Working days",
  weekdayLetters: ["M", "T", "W", "T", "F", "S", "S"] as const,
  weekdayNames: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const,
  toastCreated: "Assignment created",
  toastUpdated: "Assignment updated",
  toastDeleted: "Assignment deleted",
  toastPublished: "Assignments published",
  toastMaxRange: "Maximum range is 8 weeks",
  hoursSuffix: (h: string) => `${h}h`,
  perDay: (h: string) => `${h}h/d`,
  addAssignmentAt: (name: string, date: string) => `Create assignment for ${name} on ${date}`,
  addMilestoneAt: (date: string) => `Add milestone on ${date}`,
} as const;
